<template lang="html">
  <div
    class="ai-image-upload upbox"
    :style="style"
    :draggable="false"
  > 
    <div v-if="value" class="del" @click="del" title="删除">
      <i class="el-icon-delete"></i>
    </div>
    <div v-if="!value"  @click="onClick" class="ai-image-upload__info">
      <span class="ai-image-upload__text" :style="textStyle">{{ text }}</span>
      <span
        v-if="sub && sub.length"
        class="ai-image-upload__text ai-image-upload__text--sub"
      >
        {{ sub }}
      </span>
    </div>
    <div v-else  @click="onClick" class="ai-image-upload__preview" :draggable="false">
      <img
        :src="value"
        class="ai-image-upload__image"
        :draggable="false"
      >
    </div>
    <input
      ref="uploader"
      type="file"
      class="ai-image-upload__input"
      :accept="accept"
      @change="previewImage"
    >
  </div>
</template>

<script>
// import { upload } from '@/api/file'
import { uploadImage } from '@/api/map';
export default {
  name: 'ImageUpload',
  props: {
    text: { type: String, default: '上传文件' },
    sub: { type: String, default: '' },
    accept: { type: String, default: 'image/*' },
    value: { type: String, default: null },
    width: { type: String, default: '100px' },
    height: { type: String, default: '100px' },
    size: { type: String, default: 'normal' },
    disable: { type: Boolean, default: false },
    disableMessage: { type: String, default: '不可上传' },
    maxFileSize: { type: Number, default: 2 },
    maxFileSizeMark: { type: Boolean, default: false },
    fileTypeAccept: { type: Array,
      default() {
        return []
      } }
  },
  data: () => ({
    imagePreviewing: null,
    fileType: null,
  }),
  computed: {
    style() {
      const style = {}
      if (this.width) {
        style.width = Number.isNaN(Number(this.width)) ? this.width : `${Number(this.width)}px`
      }
      if (this.height) {
        style.height = Number.isNaN(Number(this.height)) ? this.height : `${Number(this.height)}px`
      }
      return style
    },
    iconStyle() {
      const style = {}
      if (this.size === 'small') {
        style.width = '18px'
        style.height = '18px'
        style.margin = '12px 0 8px'
      }
      return style
    },
    textStyle() {
      const style = {}
      if (this.size === 'small') {
        style['font-size'] = '10px'
      }
      return style
    }
  },
  watch: {
  },
  methods: {
    onClick() {
      if (this.disable) {
        this.$message({
          message: this.disableMessage,
          type: 'warning'
        })
        return
      }
      this.$refs.uploader.click()
    },
    del() {
      this.$emit('input', '')
      this.$emit('change', '')
    },
    async previewImage() {
      const fileReader = new FileReader()
      const file = this.$refs.uploader.files[0]
      this.fileType = file.name.slice(file.name.indexOf('.') + 1)
      if (!this.fileTypeAccept.includes(this.fileType)) {
          this.$message.error('上传图片格式错误') 
          return
      }
      // fileReader.addEventListener('load', async () => {
      // }, false)
      if (file) {
        if (this.maxFileSizeMark && file.size / 1024 > this.maxFileSize * 1024) {
          this.$message({
            message: `上传不超过 ${this.maxFileSize} M`,
            type: 'warning'
          })
          this.$refs.uploader.value = ''
          return
        }
        // fileReader.readAsDataURL(file)
        const form = new FormData()
        form.append('file', file)
        const { data } = await uploadImage({data: form})
        this.$emit('input', data)
        this.$emit('change', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upbox {
  position: relative;
  overflow: hidden;
  .del{
    color: #000;
    top: 8px;
    right: 8px;
    position: absolute;
  }
}
.ai-image-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  background-color: #fff;

  .ai-image-upload__info {
    width: 100%;
    height: 100%;
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__plus {
    width: 28px;
    height: 28px;
    margin: 16px 0 12px;
  }

  &__text {
    margin-top: 20px;
    color: #666;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    user-select: none;

    &--sub {
      font-size: 8px;
    }
  }

  &__input {
    visibility: hidden;
  }

  &__image {
    width: 100%;
    height: 100%;
    padding: 2px;
    object-fit: contain;
  }

  &__preview {
    width: 100%;
    height: 100%;
  }
}
</style>
